// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { SaleActivityDataGrid } from "../components/SaleActivity/SaleActivityDataGrid";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";

const SaleActivityContent = () => {
  return <SaleActivityDataGrid />;
};

export function SaleActivityList() {
  const authRequest = {
    ...loginRequest,
  };

  return (
    <MsalAuthenticationTemplate
    interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <SaleActivityContent />
    </MsalAuthenticationTemplate>
  );
}
